import React from 'react';
// import { $eq } from '../filters';
import { camelCase, startCase } from 'lodash';
import { EntityNameColumn } from '@components/entity-name-column';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import { Chip, Tooltip, Typography, Grid, Avatar } from '@material-ui/core';
import { useMemo, useState, useEffect, useRef } from 'react';
import CopyClipboard from '@material-ui/icons/AttachFile';
import { uniq, uniqBy } from 'lodash';
import { ColoredAvatar, ColoredChip } from '@components/colored-elements';
import { orange, blue, deepOrange, pink, indigo, teal, cyan } from '@material-ui/core/colors';
type EnumObject = { label: React.ReactNode; value: any };
type EnumMap = EnumObject[];
import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import CompanyDefaultIcon from '@icon/company-default';
import { readableDate, toPercentage, YmdStrToDate } from '@lib/common';
import { format, compareAsc } from 'date-fns';
import formatDistance from 'date-fns/formatDistance';
import differenceInDays from 'date-fns/differenceInDays';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import { useDefaultImage } from '@lib/common';
import { TimeAgo } from '@components/time-ago';
// import { Link } from 'react-router-dom';
import { Link } from '@material-ui/core';
import { windowObj } from '@lib/common';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Box from '@material-ui/core/Box';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    iframeStyle: {
      '& > *':{
        maxWidth: '100% !important',
        maxHeight: '100% !important',
      }
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    orange: {
      color: theme.palette.getContrastText(deepOrange[500]),
      backgroundColor: deepOrange[500],
    },
    containedImage: {
      '& .MuiAvatar-img': {
        objectFit: 'contain',
      },
    },
    
  })
);

const ContainedAvatar = withStyles({
  img: {
    objectFit: 'contain',
  },
})(Avatar);
/**
 * Convert a string based enum into objects
 * and redable labels.
 *
 * @param enum_ The enum to convert
 */
export const createEnumMap = (enum_: Record<string, any>, retainSpecialChars = false): EnumMap =>
  Object.values(enum_).map(value => ({
    label: retainSpecialChars ? value : startCase(camelCase(value)),
    value,
  }));

/**
 * Render a enum map to Select options.
 * @param enumMap The Enum map
 */
export const EnumsToOptions = (enumMap: EnumMap) => (
  <>
    {enumMap.map(v => (
      <option key={v.value} value={v.value}>
        {v.label}
      </option>
    ))}
  </>
);

export const CellForMediaName = ({ row }) => {
  // console.log({"row_original":row.original})
  const [shown, setShown] = React.useState(false)
  
  const youtube_regex  = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  const vimeo_regex = /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/
  // const url = 'https://youtu.be/eP85vRoRqdM';
  // const url = 'https://player.vimeo.com/video/696843222';
  
  const original_path = row.original.media_url;
  let video_url = original_path;
  let video_label = '';
  
  if(original_path?.match(youtube_regex)){
    var id = original_path.match(youtube_regex)[1];
    // console.log({"match": id})
    video_url = ('https://www.youtube.com/embed/' + id);
    video_label = original_path;
  }
  else if (original_path?.match(vimeo_regex)){
    var id = original_path.match(vimeo_regex)[4];
    video_url = 'https://player.vimeo.com/video' + id;
    video_label = original_path;
  }
  else{
    video_url = original_path
    if(original_path != null){
      const s3_url = original_path.split('/');
    // console.log(s3_url[s3_url.length - 1], "s3 url");
      video_label = s3_url[s3_url.length - 1];
      if(row?.original?.attach_b64 != null){
        if(row?.original?.media_type == 'pdf'){
          video_url = "data:application/pdf;base64, "+row?.original?.attach_b64
        }else{
          video_url = "data:image/png;base64, "+row?.original?.attach_b64
        }
        // console.log(row.original, "Original_row")
        
        // URL.createObjectURL(row?.original?.attach_b64)
        video_label = row?.original?.file_name
      }
    }
    else {
      if(row?.original?.media_type == 'pdf'){
        video_url = "data:application/pdf;base64, "+row?.original?.attach_b64
      }else{
        video_url = "data:image/png;base64, "+row?.original?.attach_b64
      }
      // console.log(row.original, "Original_row")
      
      // URL.createObjectURL(row?.original?.attach_b64)
      video_label = row?.original?.file_name
    }
    

  }
  // const youtube_parser = (url) => {
  //   var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  //   var match = url.match(regExp);
  //   return (match && match[7].length == 11) ? match[7] : false;
  // }
  // console.log({"row_original": row.original})
  // console.log({"parser": youtube_parser('https://www.youtube.com/watch?v=eP85vRoRqdM')})
  // if (!row.original.media_path) {
  //   var video_url = 'https://www.youtube.com/embed/' + youtube_parser('https://www.youtube.com/watch?v=eP85vRoRqdM');
  // }

  return (
    <div>
      {shown ? <VideoModal src={video_url} onClose={() => setShown(false)} media_type={row?.original?.media_type} /> : null}

      <Chip color="secondary" onClick={() => setShown(!shown)} label={video_label}

      />
      {/* <button onClick={() => setShown(!shown)}>{row.original.file_name ? row.original.file_name : row.original.media_url}</button> */}
    </div>
  )
  // console.log({"row": row.original})
  // return row?.original?.primary_company_name
  // return row?.original?.file_name ? row.original.file_name :( row.original.media_url) ? row.original.media_url : '';

  // return (row?.original?.company_types?.length) > 0 ? row.original.vtr_company_name : row.original.group_company_name
};

// const style = {
//   position: 'absolute' as 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: '100%',
//   height: 'auto',
//   bgcolor: 'background.paper',
//   border: '2px solid #000',
//   boxShadow: 24,
//   p: 4,
// };
const style = {
  image_style: {
   maxWidth: '100%',
   maxHeight: '100%'
 }
};

const VideoModal = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  return <div style={{ position: "fixed", width: '50', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: "rgba(0,0,0,0.5)" }}>
    {/* const [open, setOpen] = React.useState(false); */}

    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={() => props.onClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    ><Fade in={open}>
        <Box  style={{
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          width: 'auto',
          height: 'auto',
          transform: 'translate(-50%, -50%)',
          // width: 650,
          border: '2px solid #000',
          maxWidth:'100% !important',   
          maxHeight:'100% !important',     
          display:'block',
        }}>
          <div className={classes.iframeStyle}>
          {(props.media_type == 'video' || props.media_type == 'pdf') ? <iframe
            
            scrolling="no"
            title={props.src}
            allowFullScreen
            frameBorder="0"
            height="315px"
            src={props.src}
            style={style.image_style}
            // src={'https://player.vimeo.com/video/696843222'}
            width="560px"
          /> : <img src={props.src} height="315px" />}
          </div>
          
        </Box>
      </Fade>
    </Modal>

  </div>
}


/**
 * Higher order function to create c
 * @param entity The entity to create object for.
 */
export const CellForCompanyServices = ({ row }) => {
  // console.log({ "row": row })
  const max_limit: number = 2;
  // const list_of_company_services = row?.original?.associated_services
  //   ? uniqBy(row?.original?.associated_services, 'name')
  //   : [];
    const list_of_company_services = [];
  const title = list_of_company_services
    .slice(max_limit)
    .map(eachCompanyType => eachCompanyType['name'])
    .join(', ');
  const sliced = list_of_company_services.slice(0, max_limit);
  return (
    row?.original?.associated_services && (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
        {sliced.map((eachCompanyService, index) => {
          return (
            <div key={index} style={{ display: 'flex' }}>
              <Tooltip title={eachCompanyService['name']}>
                <ColoredChip
                  colored={blue[500]}
                  size="small"
                  // variant="outlined"
                  label={eachCompanyService['name']}
                />
              </Tooltip>
              {index === sliced.length - 1 && list_of_company_services.length - max_limit > 0 ? (
                <>
                  &nbsp;
                  <Tooltip title={title}>
                    <span style={{ fontWeight: 'bold', paddingLeft: '3px' }}>{`+${list_of_company_services.length - max_limit
                      }`}</span>
                  </Tooltip>
                </>
              ) : null}
            </div>
          );
        })}
      </div>
    )
  );
};

export const CellForCompanyProjects = ({ row }) => {
  const max_limit: number = 2;
  const list_of_company_projects = row.original.associated_projects
    ? uniqBy(row.original.associated_projects, 'title')
    : [];

  const title = list_of_company_projects
    .slice(max_limit)
    .map(eachCompanyType => eachCompanyType['title'])
    .join(', ');
  const sliced = list_of_company_projects.slice(0, max_limit);
  return (
    row.original.associated_projects && (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
        {sliced.map((eachCompanyProjects, index) => {
          return (
            <div key={index} style={{ display: 'flex' }}>
              <Tooltip title={eachCompanyProjects['title'] ? eachCompanyProjects['title'] : eachCompanyProjects['original_title']}>
                <ColoredChip
                  colored={blue[500]}
                  size="small"
                  // variant="outlined"
                  label={eachCompanyProjects['title'] ? eachCompanyProjects['title'] : eachCompanyProjects['original_title']}
                />
              </Tooltip>
              {index === sliced.length - 1 && list_of_company_projects.length - max_limit > 0 ? (
                <>
                  &nbsp;
                  <Tooltip title={title}>
                    <span style={{ fontWeight: 'bold', paddingLeft: '3px' }}>{`+${list_of_company_projects.length - max_limit
                      }`}</span>
                  </Tooltip>
                </>
              ) : null}
            </div>
          );
        })}
      </div>
    )
  );
};